export default __webpack_public_path__ + "static/media/checklist.25cf0918.png";